import i18n from 'i18nextInstance';

export const HEADERS = [{
    flex: 6,
    key: 'workplace_name',
    label: i18n.t('Lugar de trabajo')
}, {
    format: () => ({
        center: true
    }),
    key: 'absence_rate',
    label: '%'
}];

export const downloadHeaders = [{
    key: 'workplace_name',
    label: i18n.t('Lugar de trabajo')
}, {
    key: 'absence_rate',
    label: `${ i18n.t('Tasa de ausentismo') } (%)`
}, {
    key: 'workplace_employees',
    label: i18n.t('Cantidad de empleados')
}];
